import { render, staticRenderFns } from "./addMonitorPlan.vue?vue&type=template&id=33f4af95"
import script from "./addMonitorPlan.vue?vue&type=script&lang=js"
export * from "./addMonitorPlan.vue?vue&type=script&lang=js"
import style0 from "./addMonitorPlan.vue?vue&type=style&index=0&id=33f4af95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports